(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cpc-journal-index"]) return;
  try {
    
function initReadingGrids(){
document.querySelectorAll('.cpc-reading-grid').forEach(root=>{
const filters=root.querySelector('.cpc-reading-grid__filters');
if(!filters||filters.dataset.ready)return;
filters.dataset.ready='true';
filters.hidden=false;
filters.addEventListener('click',event=>{
const button=event.target.closest('button[data-filter]');
if(!button)return;
filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
root.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter});
});
});
}
initReadingGrids();
document.addEventListener('shopify:section:load',initReadingGrids);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
